import styled from '@emotion/styled';

/**
 * Произвольный элемент в заголовке Section.
 */
export const Aside = styled.div`
  padding-left: 1.25rem;
`;
